
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import ManualBillingDocument from '@/extend/classes/ManualBillingDocument';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeManualBillingDocument' })

export default class storeManualBillingDocument extends VuexModule {
  // States
  private reccords: ManualBillingDocument[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get manualBillingDocumentLoading (): boolean {
    return this.dataLoading;
  }
  private get manualBillingDocumentRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get manualBillingDocumentLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewManualBillingDocument() {
    return (): ManualBillingDocument => { 
      return this.getManualBillingDocument(0, true);
    }
  }

  
  public get getManualBillingDocument () {
    return (id: number, canCreate = false): ManualBillingDocument => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id ManualBillingDocument can't be 0")
        return new ManualBillingDocument();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new ManualBillingDocument();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            ManualBillingDocument.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromManualBillingDocument(data.reccords[0] as ManualBillingDocument);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listManualBillingDocument (): ManualBillingDocument[] {
    return this.reccords;
  }

  public get listConfigManualBillingDocument (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mManualBillingDocumentRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mManualBillingDocumentClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mManualBillingDocumentLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mManualBillingDocumentLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(ManualBillingDocument.fromJson(reccord as ManualBillingDocument));
    })
    ManualBillingDocument.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mManualBillingDocumentConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mManualBillingDocumentCreated (obj: ManualBillingDocument): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareManualBillingDocument(obj)) {
          api.fromManualBillingDocument(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareManualBillingDocument(obj)) {
            api.fromManualBillingDocument(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mManualBillingDocumentUpdated (obj: ManualBillingDocument): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareManualBillingDocument(obj)) {
          api.fromManualBillingDocument(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mManualBillingDocumentDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerManualBillingDocument (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.manualBillingDocumentRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerManualBillingDocument(this.manualBillingDocumentCreated, this.manualBillingDocumentUpdated, this.manualBillingDocumentDeleted);
          this.mManualBillingDocumentRegistered();
        } else {
          setTimeout(() => resolve(this.registerManualBillingDocument(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.manualBillingDocumentLoading && !this.manualBillingDocumentLoaded) {
          this.mManualBillingDocumentLoading(true);
          return ManualBillingDocument.list(filter)
            .then((data: ListData) => {
              this.mManualBillingDocumentLoaded(data);
              this.mManualBillingDocumentLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredManualBillingDocument (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.manualBillingDocumentLoading) {
        this.mManualBillingDocumentLoading(true);
        return ManualBillingDocument.list(filter)
          .then((data: ListData) => {
            this.mManualBillingDocumentLoaded(data);
            this.mManualBillingDocumentLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createManualBillingDocument (obj: ManualBillingDocument): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      return ManualBillingDocument.fromJson(obj).createForStoreManualBillingDocument()
        .then((reccords) => {
          this.mManualBillingDocumentCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateManualBillingDocument (obj: ManualBillingDocument): Promise<ManualBillingDocument> {
    return new Promise((resolve, reject) => {
      return ManualBillingDocument.fromJson(obj).updateForStoreManualBillingDocument()
        .then((reccords) => {
          this.mManualBillingDocumentUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  private manualBillingDocumentCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mManualBillingDocumentConfigUpdated(config)
    const obj = objConfig.obj as ManualBillingDocument;
    this.mManualBillingDocumentCreated(ManualBillingDocument.fromJson(obj));
  }

  @Action
  private manualBillingDocumentUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mManualBillingDocumentConfigUpdated(config)
    const obj = objConfig.obj as ManualBillingDocument;
    this.mManualBillingDocumentUpdated(ManualBillingDocument.fromJson(obj));
  }

  @Action
  private manualBillingDocumentDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as ManualBillingDocument;
    this.mManualBillingDocumentDeleted(obj.id);
  }
}
